import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // 25 s default — prevents the UI hanging forever on a stalled API request.
  // Long uploads (videos / chunked) override this via per-call config.
  timeout: 25000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Only wipe the local session if the 401 came from a request that
    // actually carried a token — otherwise we destroy the session in
    // response to our own "missing token" error and end up in a loop.
    // Also exempt /auth/* endpoints (login itself returns 401 on bad
    // password — that's not a session-validity failure).
    if (err.response?.status === 401) {
      const config = err.config || {};
      const url = config.url || "";
      const sentToken = config.headers?.Authorization;
      const isAuthRoute = url.includes("/auth/login") || url.includes("/auth/pin/")
        || url.includes("/auth/register") || url.includes("/auth/forgot");
      if (sentToken && !isAuthRoute) {
        localStorage.removeItem("pp_token");
        localStorage.removeItem("pp_user");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
